import InputWrapper from "../../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../../../../styles/LayoutStyles";

function FontFormView({
  selectedLabelItem,
  selectedLabelItemIndex,
  onFontSizeChange,
  onFontWeightChange,
  onTextAlignChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <StyledFlexRow>
        <StyledFlexItem>
          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.label_items.*.font_size"
            )}
            required
            error={EVAApiHelper.getResponseError(
              `label_items.${selectedLabelItemIndex}.font_size`,
              submitError
            )}
          >
            <StyledInput
              type="number"
              value={selectedLabelItem.font_size}
              onChange={onFontSizeChange}
            />
          </InputWrapper>
        </StyledFlexItem>

        <StyledFlexItem>
          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.label_items.*.font_weight"
            )}
            required
            error={EVAApiHelper.getResponseError(
              `label_items.${selectedLabelItemIndex}.font_weight`,
              submitError
            )}
          >
            <Select
              options={[
                {
                  value: "normal",
                  label: translate("eva.main.css.font_weight.values.normal"),
                },
                {
                  value: "bold",
                  label: translate("eva.main.css.font_weight.values.bold"),
                },
              ]}
              value={selectedLabelItem.font_weight}
              onChange={onFontWeightChange}
            />
          </InputWrapper>
        </StyledFlexItem>
      </StyledFlexRow>

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.label_items.*.text_align"
        )}
        required
        error={EVAApiHelper.getResponseError(
          `label_items.${selectedLabelItemIndex}.text_align`,
          submitError
        )}
      >
        <Select
          options={[
            {
              value: "left",
              label: translate("eva.main.css.text_align.values.left"),
            },
            {
              value: "center",
              label: translate("eva.main.css.text_align.values.center"),
            },
            {
              value: "right",
              label: translate("eva.main.css.text_align.values.right"),
            },
          ]}
          value={selectedLabelItem.text_align}
          onChange={onTextAlignChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default FontFormView;
